<template>
    <div class="table__responsive">
        <table class="table">
            <thead v-if="!loadingDocumentTemplates && documentTemplates.length">
                <tr>
                    <th>{{$t('document_templates.table.header.id')}}</th>
                    <th>{{$t('document_templates.table.header.name')}}</th>
                    <th class="table__cell--icon"></th>
                    <th class="table__cell--icon"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loadingDocumentTemplates" class="table--loading">
                    <td colspan="5">
                        <div class="spinner"></div>
                        <div class="text-center loading_text">{{$t('document_templates.table.loading')}}</div>
                    </td>
                </tr>

                <tr v-else-if="!documentTemplates.length" class="table--empty">
                    <td colspan="5">
                        <div class="text-center">{{$t('document_templates.table.no_document_templates')}}</div>
                    </td>
                </tr>

                <tr v-else v-for="template in documentTemplates" :key="template.id">
                    <td>{{ template.id }}</td>
                    <td>{{ template.name }}</td>
                    <td><span @click="editTemplate(template)" v-tooltip.right="'Edit'" class="table__icon icons icon-pencil"></span></td>
                    <td><span @click="showDeleteTemplateModal(template)" v-tooltip.bottom="$t('document_templates.table.delete')" class="table__icon icons icon-trash"></span></td>
                </tr>

                <tr class="table__navigation" v-if="documentTemplatesMeta && documentTemplatesMeta.last_page > 1">
                    <td colspan="5">
                        <pagination :meta="documentTemplatesMeta" @goToPage="goToPage"/>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import Pagination from '@/components/tables/Pagination';
    import { GET_DOCUMENT_TEMPLATES } from '@/store/modules/document-templates';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class DocumentTemplatesTable extends Vue {
        mounted() {
            this.$store.dispatch(GET_DOCUMENT_TEMPLATES, {});
        }

        get documentTemplates() {
            return this.$store.state.document_templates.templates;
        }

        get loadingDocumentTemplates() {
            return this.$store.state.document_templates.loading;
        }

        get documentTemplatesMeta() {
            return this.$store.state.document_templates.templatesMeta;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_DOCUMENT_TEMPLATES, { params: { page: pageNo }});
        }

        editTemplate(template) {
            this.$router.push({ name: 'document-template', params: { id: template.id }});
        }

        showDeleteTemplateModal(template) {
            const content = {
                title: this.$t('modals.delete_template.title'),
                message: this.$t('modals.delete_template.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteTemplate, template});
        }

        deleteTemplate({template}) {
            template.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.template.delete_success'));
                    this.$store.dispatch(GET_DOCUMENT_TEMPLATES, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.template.delete_error')));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/document-templates/DocumentTemplatesTable.vue